<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Voucher Report</div>
        <div>
          <bread-crumb :bread-crumbs="['Voucher Report']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
    </v-card>

    <v-card>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-2">
        <v-card class="pa-1 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid">
            <v-row class="ms-1 me-2 mt-2">
              <v-col>
                <label class="my-0 rounded labelFontsize required">
                  Ledger Head
                </label>
                <v-autocomplete
                  class="rounded"
                  v-model="voucherEntry.gl_sub_head_code"
                  dense
                  outlined
                  item-text="text"
                  item-disabled="had_sub_list"
                  item-value="value"
                  placeholder="Select ledger head"
                  :rules="FieldRequired('Ledger Head')"
                  :items="ledgerIds"
                >
                  <template v-slot:item="data">
                    <template class="border">
                      <v-list-item
                        dense
                        ripple
                        @mousedown.prevent
                        :class="
                          data.item.had_sub_list
                            ? 'light-gray primary--text'
                            : ''
                        "
                        v-if="data.item.isheader"
                      >
                        <v-list-item-content class="ma-0 pa-0">
                          <v-list-item-title class="d-flex ma-0 pa-0"
                            ><span class="pt-1 ps-3 font-weight-bold">{{
                              data.item.text
                            }}</span></v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        dense
                        class="ps-6 border-list"
                        v-if="!data.item.isheader"
                      >
                        <v-list-item-content class="ma-0 ps-6 mt-2">
                          <v-list-item-title
                            ><v-icon class="pb-2">mdi-arrow-right-bottom</v-icon
                            >{{ data.item.text }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <label class="my-0 rounded labelFontsize">
                  Voucher From Date
                </label>
                <v-text-field
                  v-model="from_date"
                  :items="voucherReportList"
                  :max="maxDate"
                  :rules="[validateFromDate]"
                  label="From Date"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                ></v-text-field>
              </v-col>
              <v-col>
                <label class="my-0 rounded labelFontsize">
                  Voucher To Date
                </label>
                <v-text-field
                  v-model="to_date"
                  :items="voucherReportList"
                  :max="maxDate"
                  :rules="[validateToDate]"
                  label="To Date"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                ></v-text-field>
              </v-col>
              <v-col>
                <label class="my-0 rounded labelFontsize">
                  Voucher Number
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Enter Voucher Number"
                  v-model="invoiceNum"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="12" lg="12" xs="12" class="mb-3">
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="getDataByDate()"
                  class="text-capitalize me-3 text-decoration-none float-right"
                  ><v-icon class="me-2" small
                    >mdi-content-save-plus-outline</v-icon
                  >Generate Report
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          :items="voucherReportList"
          show-group-by
          group-by="voucher_num"
          dense
          class="mt-5"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
              <div class="d-flex justify-space-between align-items-center py-2">
                <div>
                  <v-btn @click="toggle" x-small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-plus</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                  </v-btn>
                  <span class="mx-5 font-weight-bold">
                    Voucher Reference No: {{ group }}</span
                  >
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>

      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService";
import { partnerRoute } from "@/utils/validation.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
export default {
  name: "Voucher Report",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  data: () => {
    return {
      FieldRequired,
      FieldNumbRequired,
      ...partnerRoute,

      ledgerIds: [],
      loaderOverlay: false,

      voucherEntry: {
        gl_sub_head_code: "",
      },
      voucherReportList: [],
      from_date: null,
      to_date: null,
      invoiceNum: null,
      // defaultVoucherEntry: {
      //   gl_sub_head_code: "",
      // },
      headers: [
        { text: "ID", value: "id", groupable: false },
        { text: "Voucher Name", value: "voucher_name", groupable: false },
        { text: "Txn Type", value: "part_tran_type", groupable: false },
        // { text: "DOT", value: "tran_date", groupable: false },
        { text: "USD", value: "usd_amt", groupable: false },
        { text: "Amount", value: "lc_amt_cr", groupable: false },
        { text: "Txn Currency", value: "trn_currency", groupable: false },
        { text: "Remarks", value: "tran_rmks", groupable: false },
        // { text: "Posted", value: "is_active", groupable: false },
        // { text: "Approve", value: "is_active", groupable: false },
        // { text: "Actions", value: "actions" },
      ],
    };
  },

  mounted() {
    this.getallLedgersDropdown();
  },
  computed: {
    maxDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },

  methods: {
    async getallLedgersDropdown() {
      try {
        const responseData = await setupService.getallLedgersDropdown();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((ele) => {
            this.ledgerIds.push({
              text: ele.name,
              value: ele.ledger_id,
              isheader: true,
              had_sub_list: ele.sub_ledger_list.length > 0 ? true : false,
            });
            if (ele.sub_ledger_list.length > 0) {
              ele.sub_ledger_list.map((sub_ele) => {
                this.ledgerIds.push({
                  text: sub_ele.name,
                  value: sub_ele.ledger_id,
                  isheader: false,
                });
              });
            }
          });
          console.log("this.ledgerIds", this.ledgerIds);
        }

        this.ledger_obj = responseData.data.data;
      } catch (e) {
        console.error(e);
      }
    },

    async getDataByDate() {
      if (this.$refs.form.validate()) {
        this.loaderOverlay = true;
        let params;

        params = {
          ledgerHead: this.voucherEntry.gl_sub_head_code,
          from_date: this.from_date,
          to_date: this.to_date,
        };
        if (this.invoiceNum) {
          params.voucher_num = this.invoiceNum;
        }
        console.log(params);

        try {
          const response = await treasuryService.getVoucherReportByDate(params);
          console.log("response data ", response);
          if (response.data.status_code === 200) {
            this.voucherReportList = response.data.data;
            console.log("voucherList", this.voucherReportList);
            this.stoploader();
          } else {
            this.voucherReportList = [];
            this.stoploader();
          }
        } catch (error) {
          this.stoploader();
          console.error(error);
          this.voucherReportList = [];
        }
      }
    },

    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
  },
};
</script>
<style>
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.required:after {
  content: " *";
  color: red;
}
</style>
